import React from "react";
import { getSubmitButtonOptions, } from "@rjsf/utils";
export default function SubmitButton(props) {
    const { submitText, norender, props: submitButtonProps, } = getSubmitButtonOptions(props.uiSchema);
    if (norender) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("button", { type: "submit", className: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800", ...submitButtonProps }, submitText)));
}
//# sourceMappingURL=SubmitButton.js.map